import React, { useState, useEffect } from 'react';
import { Tabs } from 'antd';
import { useSelector } from 'react-redux';
import Main from '../../components/layout/Main';
import SurveysListingContent from '../../components/SurveysListing/SurveysListingContent';
import SurveysListingPremadeContent from '../../components/SurveysListing/SurveysListingPremadeContent';
import BvmSurveyAdminListing from '../../components/SurveysListing/BvmSurveyAdminListing';
import { CombinedStates } from '../../core/types';

import './surveysListing.scss';

const SurveysListing = () => {
    const toolbar = [{ label: 'Item 1', link: '/abc', iconName: 'home' }];
    const [activeTab, setActiveTab] = useState('1');

    // Listen to Redux state for survey creation
    const { isCreatingFromPremade } = useSelector((state: CombinedStates) => state.survey);
    const { userData } = useSelector((state: CombinedStates) => state.user);

    // Track previous isFetching state to detect when survey creation completes
    const [prevIsFetching, setPrevIsFetching] = useState(isCreatingFromPremade);

    // Effect to detect successful survey creation from premade and switch to first tab
    useEffect(() => {
        // If isFetching changed from true to false, it means an operation completed
        if (prevIsFetching && !isCreatingFromPremade) {
            // Check if we're currently on the second tab (premade surveys)
            if (activeTab === '2') {
                // Switch to first tab (regular surveys) after successful creation
                setActiveTab('1');
            }
        }
        setPrevIsFetching(isCreatingFromPremade);
    }, [isCreatingFromPremade, prevIsFetching, activeTab]);

    const tabItems = [
        {
            key: '1',
            label: 'Apklausos',
            children: <SurveysListingContent />,
        },
        {
            key: '2',
            label: 'Paruoštos apklausos',
            children: <SurveysListingPremadeContent />,
        },
        // Hide BVM apklausos tab for users with role 5 (Mokykla)
        ...(userData?.role_id !== 5 ? [{
            key: '3',
            label: 'BVM įsivertinimo ataskaita',
            children: <BvmSurveyAdminListing />,
        }] : []),
    ];

    return (
        <Main
            className="data-listing"
            title={<div>Apklausų administravimas</div>}
            headerTitle={<div>Apklausų administravimas</div>}
            menuWidth={350}
            menuPlacement="left"
            toolbar={toolbar}
            showFooter={false}
            floatingHeader={false}
            footerContent={<div />}
            floatingFooter
            backLink={false}
            breadcrumb={null}>
            <Tabs
                activeKey={activeTab}
                onChange={setActiveTab}
                items={tabItems}
                type="card" />
        </Main>
    );
};

export default SurveysListing;

SurveysListing.propTypes = {};
